"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCustomerFailure = exports.createCustomerFailed = exports.createCustomerSuccess = exports.createCustomerRequest = exports.setYtjCompanyFailure = exports.setYtjCompanySuccess = exports.setYtjCompanyRequest = exports.updateCustomerField = exports.toggleNewCustomerModal = exports.setCustomerSearchString = exports.searchCustomerFailed = exports.searchCustomerSuccess = exports.searchCustomerRequest = void 0;
const actions = require("../../actionTypes/firstLogin/customer");
const searchCustomerRequest = (searchString) => ({
    type: actions.SEARCH_CUSTOMER_REQUEST,
    payload: searchString
});
exports.searchCustomerRequest = searchCustomerRequest;
const searchCustomerSuccess = (customers) => ({
    type: actions.SEARCH_CUSTOMER_SUCCESS,
    payload: customers
});
exports.searchCustomerSuccess = searchCustomerSuccess;
const searchCustomerFailed = (error) => ({
    type: actions.SEARCH_CUSTOMER_FAILED,
    payload: error
});
exports.searchCustomerFailed = searchCustomerFailed;
const setCustomerSearchString = (searchString) => ({
    type: actions.SET_CUSTOMER_SEARCH_STRING,
    payload: searchString
});
exports.setCustomerSearchString = setCustomerSearchString;
const toggleNewCustomerModal = (force = null) => ({
    type: actions.TOGGLE_NEW_CUSTOMER_MODAL,
    payload: force
});
exports.toggleNewCustomerModal = toggleNewCustomerModal;
const updateCustomerField = (key, value) => ({
    type: actions.UPDATE_NEW_CUSTOMER_FIELD,
    payload: {
        key,
        value
    }
});
exports.updateCustomerField = updateCustomerField;
const setYtjCompanyRequest = (company) => ({
    type: actions.SET_YTJ_COMPANY_REQUEST,
    payload: company
});
exports.setYtjCompanyRequest = setYtjCompanyRequest;
const setYtjCompanySuccess = (company) => ({
    type: actions.SET_YTJ_COMPANY_SUCCESS,
    payload: company
});
exports.setYtjCompanySuccess = setYtjCompanySuccess;
const setYtjCompanyFailure = (error) => ({
    type: actions.SET_YTJ_COMPANY_FAILURE,
    payload: error
});
exports.setYtjCompanyFailure = setYtjCompanyFailure;
const createCustomerRequest = (company) => ({
    type: actions.CREATE_CUSTOMER_REQUEST,
    payload: company
});
exports.createCustomerRequest = createCustomerRequest;
const createCustomerSuccess = (customer) => ({
    type: actions.CREATE_CUSTOMER_SUCCESS,
    payload: customer
});
exports.createCustomerSuccess = createCustomerSuccess;
const createCustomerFailed = (error) => ({
    type: actions.CREATE_CUSTOMER_FAILED,
    payload: error
});
exports.createCustomerFailed = createCustomerFailed;
const validateCustomerFailure = (errors) => ({
    type: actions.VALIDATE_CUSTOMER_FAILURE,
    payload: {
        errors
    }
});
exports.validateCustomerFailure = validateCustomerFailure;
//# sourceMappingURL=customer.js.map